export const UPDATE_LOADING = "UPDATE_LOADING";
export const UPDATE_QUERY_RESULT = "UPDATE_QUERY_RESULT";
export const CLICK_UPDATE_THEME = "CLICK_UPDATE_THEME";
export const UPDATE_ARTIST_INFO = "UPDATE_ARTIST_INFO";
export const UPDATE_ARTIST_ALBUMS = "UPDATE_ARTIST_ALBUMS";
export const UPDATE_ARTIST_TRACKS = "UPDATE_ARTIST_TRACKS";
export const TOGGLE_LANGUAGE = "TOGGLE_LANGUAGE";